import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuItem from '@material-ui/core/MenuItem';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import { ConfirmJsMessage, tzStrings } from '../../helpers.js';
import TimePick from "./OnlyTimePicker";
import StartCalendar from "./StartCalendar";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import { AlertJsMessage } from './../../helpers.js';
import ScheduleMessageListing from './../assignments/ScheduleMessageListing';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';

const styles = theme => ({
    root: {
        "& .MuiInputBase-input": {
          height: "160px !important",
        },
      },
    textarea: {
      height: "190px !important"
    },
    hours: {
        height: "50px !important"
    }
});

const Schedule = withStyles(styles)(props => {
   const {
		clientEmail,
        deleteScheduleMessage,
        fetchScheduleMessages,
        saveScheduleMessage,
        fetchScheduleMessageDetail,
        isEdit,
        user,
        isMobile,
        message,
        classes
	} = props;

	const [passDate, setPassDate] = useState(new Date());
    const [data, setData] = useState({
        message: '',
        timeZoneId: '',
    });
    const times = [
        {
            label: 'AM',
            value: 'AM'
        }, {
            label: 'PM',
            value: 'PM'
        }
    ]
  
	useEffect(() => {
        if (isEdit && message) {
            fetchScheduleMessageData([message._id])
        } else {
           const timeZoneId = user.timeZoneId ?  user.timeZoneId : '';
           const date = moment(new Date());
           const hour = date.format('h');
           const min = date.format('mm');
           const timeInHour = date.format('A');
           setData({
               ...data,
               timeZoneId,
               timeFormat: timeInHour,
               hours:hour,
               minutes: min
           })
        }
	}, [clientEmail])


    const fetchScheduleMessageData = (messageIds) => {
        fetchScheduleMessageDetail(messageIds)
        .then((res) => {
           const data = res.data;
           const dataList = data.data;
           if (dataList.length > 0) {
                const list = dataList[0];
                const combineTime = moment(`${dataList[0]['selectDate']} ${dataList[0]['selectTime']}`, 'YYYY-MM-DD h:mm A');
                const hour = combineTime.format('h');
                const min = combineTime.format('mm');
                const timeInHour = combineTime.format('A');
                setData({
                    ...list,
                    timeFormat: timeInHour,
                    hours:hour,
                    minutes: min
                })
                setPassDate(new Date(dataList[0]['startDate']))
           }
        })
    }

   
    const submitData = () => {
        if(passDate === null) {
            AlertJsMessage('Date is required.');
            return;
        }
        const findTz = tzStrings.find((t) => {
            return t.id === data.timeZoneId
        })

        const now = moment(new Date());
        const formatPassDate = moment(passDate).format('YYYY-MM-DD');
        const formatPassTime = `${data.hours}:${data.minutes} ${data.timeFormat}`;
        if(!moment(`${formatPassDate} ${formatPassTime}`,"YYYY-MM-DD h:mm A", true).isValid()) {
            AlertJsMessage('Please enter valid date & time.');
            return;
        }
        
        const combineTime = moment(`${formatPassDate} ${formatPassTime}`)
        const duration = moment.duration(combineTime.diff(now));
        const mindiff = duration.asMinutes();

        if(mindiff < 10) {
            AlertJsMessage('Please select the time slot after 10 minutes.');
            return;
        } 
        saveScheduleMessage({
            ...data,
            startDate: passDate,
            clientEmail: clientEmail,
            timeZone: findTz ? findTz.value : undefined,
            selectTime: formatPassTime,
            selectDate: formatPassDate
        })
        .then((res) => {
            if(!res.isMessageAlreadyAdded) {
                props.parentData(res.messageDetails)
            }
        })
    }

    

    const handleChange = (evt) => {
        let { value, name } = evt.target
        setData({
            ...data,
            [name]: value
        })
    }

   
    const isDisbaledSave = () => {
        if(message) {
            return passDate === null 
                  || data.message === '' 
                  || data.timeZoneId === ''
                  || data.hours === ''
                  || data.minutes === ''
                  || message.isSent
        } else {
            return passDate === null 
                 || data.message === '' 
                 || data.timeZoneId === ''
                 || data.hours === ''
                 || data.minutes === ''
        }
    }

    let startDate = passDate;
    if (message) {
        startDate = moment(startDate).utc(0, true);
        const month = startDate.format('M');
        const day   = startDate.format('D');
        const year  = startDate.format('YYYY');
        startDate = new Date(`${year}-${month}-${day}`)
    }

    const changeStartDate = (data) => {
        const date = new Date(data);
        setPassDate(date);
    }


    
    return (
        <Fragment>
                <div
					style={{
					    width: '600px',
                   }}
				>
                   

                   <div style={{marginTop: '5px'}}>
                   <div style={{
                                display: 'flow-root',
                                padding: 20,
                                paddingLeft: 0,
                                width: '100%',
                                }}>
                            <div style={{
                                display: 'initial',
                                float: 'left',
                                width: '550px'
                            }}>
                                
                                       
                                                <TextField
                                                    InputProps={{
                                                        className: classes.textarea
                                                    }}
                                                    className={classes.root}
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    label="Message"
                                                    value={data.message}
                                                    multiline
                                                    rows={5}
                                                    name="message"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                />
                                            
                              <div>
                                <div style={{ float: 'left'}}>
                                 <span style={{ marginTop: '5px', marginBottom: '5px', display: 'block'}}>Select Date</span>
                                  <StartCalendar startDate={startDate} formDataPicker={'MM/YYYY/DD'} isOnlyMonthPicker={false} changeStartDate={changeStartDate}  />
                                </div> 
                                <div style={{ float: 'left', marginLeft: '10px', width: '300px'}}>
                                    <TextField
                                        style={{ maxWidth: 70, marginTop: 30, marginRight: 10 }}
                                        label="Hours"
                                        value={data.hours}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            className: classes.hours,
                                            inputProps: { min: 1, max: 12 } 
                                        }}
                                        type="number"
                                        onChange={handleChange}
                                        name="hours"
                                        variant="outlined"
                                    />
                                    <TextField
                                        style={{ maxWidth: 70, marginTop: 30, marginRight: 10 }}
                                        label="Minutes"
                                        InputProps={{
                                            className: classes.hours,
                                            inputProps: { min: 0, max: 59 } 
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={data.minutes}
                                        onChange={handleChange}
                                        name="minutes"
                                        margin="dense"
                                        variant="outlined"
                                    />
                                    <TextField
                                            style={{ maxWidth: 80, marginTop: 30, marginRight: 10 }}
                                            label={""}
                                            InputProps={{
                                                className: classes.hours,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={data.timeFormat}
                                            name="timeFormat"
                                            margin="dense"
                                            variant="outlined"
                                            select
                                            onChange={handleChange}
                                        >
                                        {times && times.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                              </div>
                              <TextField
                                    style={{marginTop: '10px'}}
                                    label="Timezone"
                                    value={data.timeZoneId}
                                    name="timeZoneId"
                                    margin="dense"
                                    variant="outlined"
                                    select
                                    onChange={handleChange}
                                >
                                {tzStrings && tzStrings.map(option => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            </div>
                        </div>
                        <div style={{ marginTop: '5px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => submitData()}
                                disabled={isDisbaledSave()}
                            >
                                <ButtonContent
                                    text="Save"
                                    icon="chevron-right" />
                            </Button>
                        </div>
                    </div>
                </div>
        </Fragment>
    );
});

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/assignments/Schedule.js